var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { accountEntityName, addAccountsToOrganizationBulkActionType, validateOrganizationSubtreeMembershipLimitFunctionName, } from '../../../../../../../backend/features/accounts/shared';
import { requireAnySystemPermission } from '../../../../../../../backend/features/permissions/shared';
import { getMaxOrganizationsPerAccount } from '../../../../../../../backend/utils/getMaxOrganizationsPerAccount';
import { showAccountsDialog } from '../../../../../../../ui/features/accounts/components/AccountsDialog';
import { handleErrorDialog, showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { FunctionClient } from '@juvare/platform-sdk-js/FunctionClient';
import { StorageClient } from '@juvare/platform-sdk-js/StorageClient';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
import { Typography } from '@mui/material';
import React from 'react';
import { mapAccountRejectedOrganizationsRowsToRequest } from '../mapAccountRejectedOrganizationsRowsToRequest';
import { showAccountsCannotBeAddedToOrganizationsDialog } from './showAccountsCannotBeAddedToOrganizationsDialog';
export const handleAddMembersToOrganization = ({ userState, organizationId, t, onReloadOrganization, onReloadTable, settings, }) => {
    function addAccountsToOrganization(accountIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const validateSubtreeMembershipLimit = (params) => new FunctionClient().executeFunction({ functionName: validateOrganizationSubtreeMembershipLimitFunctionName, params: params });
            try {
                const bulkActionParams = {
                    type: addAccountsToOrganizationBulkActionType,
                    title: t('forms.orgMembers.addingAccountsToOrg'),
                    params: {
                        organizationId,
                        filter: [{ op: 'in', id: accountIds }],
                    },
                    onClose: () => {
                        onReloadTable();
                        onReloadOrganization();
                    },
                };
                const response = yield validateSubtreeMembershipLimit({
                    accountIds,
                    organizationIds: [organizationId],
                });
                const accountRejectedOrganizationsRows = response.result;
                const hasRejectedOrganizations = Array.isArray(accountRejectedOrganizationsRows) && accountRejectedOrganizationsRows.length > 0;
                if (hasRejectedOrganizations) {
                    bulkActionParams.params.accountRejectedOrganizationsMap =
                        mapAccountRejectedOrganizationsRowsToRequest(accountRejectedOrganizationsRows);
                    showAccountsCannotBeAddedToOrganizationsDialog({
                        accountRejectedOrganizationsRows: accountRejectedOrganizationsRows,
                        onConfirm: () => launchBulkAction(bulkActionParams),
                    });
                }
                else {
                    launchBulkAction(bulkActionParams);
                }
            }
            catch (error) {
                handleErrorDialog(error);
            }
        });
    }
    showAccountsDialog({
        scope: 'manage-accounts',
        title: t('forms.orgMembers.addAccountsToOrg'),
        selectOperationName: t('common.add'),
        showAllAccounts: requireAnySystemPermission(userState, 'manage-accounts-organizations'),
        onSelect: (accountIds) => __awaiter(void 0, void 0, void 0, function* () {
            if (accountIds.length > 0) {
                const maxOrganizationsPerAccount = getMaxOrganizationsPerAccount(settings);
                if (maxOrganizationsPerAccount) {
                    const accountStorage = new StorageClient(accountEntityName);
                    const accountsWithMaxOrgAssigned = yield accountStorage.list({
                        filter: [
                            { op: 'in', id: accountIds },
                            { column: 'assignedOrgCount', op: '>=', value: maxOrganizationsPerAccount },
                        ],
                        limit: 1,
                    });
                    if (accountsWithMaxOrgAssigned.total > 0) {
                        showConfirmDialog({
                            title: t('forms.orgMembers.maxOrgPerAccount'),
                            content: (React.createElement(Typography, null, t('forms.orgMembers.maxOrgPerAccountWarning', {
                                count: accountsWithMaxOrgAssigned.total,
                                total: accountIds.length,
                            }))),
                            confirmLabel: t('common.submit'),
                            onConfirm: () => {
                                addAccountsToOrganization(accountIds);
                            },
                        });
                    }
                    else {
                        addAccountsToOrganization(accountIds);
                    }
                }
                else {
                    addAccountsToOrganization(accountIds);
                }
            }
        }),
    });
};
